import moment from 'moment';

export function BillableRegistration(data) {
  // ReSharper disable MisuseOfOwnerFunctionThis
  this.date = new Date();
  this.customer = {};
  this.type = 0;
  this.resource = null;

  this.originalQuantity = 0;
  this.originalUnitPrice = 0;
  this.originalDiscountPercentage = 0;
  this.originalVatRate = 0.21;
  this.originalVatType = 0;
  this.originalBillable = 0;
  this.quantity = null;
  this.unitPrice = null;
  this.discountPercentage = null;
  this.vatRate = null;
  this.vatType = null;
  this.billable = null;
  this.inForfait = null;
  this.originalInForfait = null;

  this.remark = null;
  this.internalRemark = null;

  this.isFixedPrice = false;
  if (data) angular.extend(this, data);

  if (this.date && typeof this.date === 'string')
    this.date = new moment(this.date.substr(0, 10)).toDate();

  this.billedQuantity = function() {
    var quantity = this.quantity != null ? this.quantity : this.originalQuantity;
    if (this.type !== 0) return quantity;
    return Math.round(quantity * 60, 10) / 60.0; //Round to minutes
  };

  this.displayTime = function() {
    //TFS 5864
    return this.billedQuantity().toTime();
  };

  this.billedUnitPrice = function() {
    return this.unitPrice != null ? this.unitPrice : this.originalUnitPrice;
  };
  this.billedDiscountPercentage = function() {
    return this.discountPercentage != null
      ? this.discountPercentage
      : this.originalDiscountPercentage;
  };

  this.billedVatRate = function() {
    return this.vatRate != null ? this.vatRate : this.originalVatRate;
  };
  this.billedVatType = function() {
    return this.vatType != null ? this.vatType : this.originalVatType;
  };

  this.isBilled = function() {
    return this.billable != null ? this.billable : this.originalBillable;
  };
  this.isInForfait = function() {
    return this.inForfait;
  };

  this.billedAmount = function() {
    return this.isBilled()
      ? this.billedUnitPrice() * (this.isFixedPrice ? 1 : this.billedQuantity())
      : null;
  };

  this.isModified = function() {
    return (
      this.quantity != null ||
      this.unitPrice != null ||
      this.vatRate != null ||
      this.vatType != null ||
      this.billable != null ||
      this.discountPercentage != null ||
      (this.price != null &&
        (this.originalPrice == null || this.originalPrice.id !== this.price.id))
    );
  };

  this.currentPrice = function() {
    return this.price ? this.price : this.originalPrice;
  };

  this.currentUnitPrice = function() {
    return this.unitPrice ? this.unitPrice : this.originalUnitPrice;
  };
  this.currentDiscountPercentage = function() {
    return this.discountPercentage ? this.discountPercentage : this.originalDiscountPercentage;
  };

  this.undo = function() {
    this.quantity = null;
    this.unitPrice = null;
    this.discountPercentage = null;
    this.vatRate = null;
    this.vatType = null;
    this.billable = null;
    this.price = null;
    this.isFixedPrice = false;
  };

  this.update = function(reg) {
    if (reg) {
      angular.extend(this, reg);
    }
  };
}
